import Page from '@digitalfemsa/cronos/declarative/Page';
import { loadable } from '@digitalfemsa/cronos/dynamic';
import { CheckoutFrameProvider } from 'app/context';
import { PluginsProvider } from 'app/features/plugins/state/pluginsContext';
import { AgreementContentPrivacyPolicy } from 'app/pages/frames/components';
import { PaymentsOptionsSkeleton } from 'app/pages/frames/components/Skeletons/PaymentOptions';
import { SharableMetadata } from 'app/pages/hosted-checkout/components/SharableMetadata';
import { TestBar } from 'app/pages/hosted-checkout/components/TestBar';
import { ViewState } from 'app/pages/hosted-checkout/interface';
import styled, { ThemeProvider } from 'styled-components';

import useCheckout from './useCheckout';
import { COMPONENT_CONTAINER_IDENTIFIER } from '../../constants';

import type { FC } from 'react';

import 'app/pages/hosted-checkout/hosted-checkout.scss';
import 'app/pages/hosted-checkout/views/Checkout/styles.scss';
import 'app/pages/hosted-checkout/views/Checkout/embeddedStyles.scss';

const CancelButton = loadable(() => import('app/features/plugins/components/CancelButtonMobile'), {
  ssr: false,
  fallback: <></>,
});

const ShoppingCartMobile = loadable(() => import('app/pages/hosted-checkout/components/ShoppingCartMobile/index'), {
  ssr: false,
  fallback: <></>,
});

const ShoppingCartDesktop = loadable(() => import('app/pages/hosted-checkout/components/ShoppingCart/index'), {
  ssr: false,
  fallback: <></>,
});

const ComponentContainer = styled.div`
  margin: auto;
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 375px;
  max-width: 100%;
  @media (min-width: 400px) {
    width: 90%;
    max-width: 550px;
  }
`;

export const EmbeddedCheckout: FC<ViewState> = (state) => {
  const onFinalizedPaymentCallback = false;
  return (
    <PluginsProvider initialValue={onFinalizedPaymentCallback}>
      <EmbeddedCheckoutContainer {...state} />
    </PluginsProvider>
  );
};

export const EmbeddedCheckoutContainer: FC<ViewState> = (state) => {
  const {
    theme,
    entity: { name: merchantName },
    checkoutRequest,
    contentLoaded,
    showIntro,
    setShowIntro,
  } = useCheckout(state);
  const { liveMode, name } = checkoutRequest;

  return (
    <ThemeProvider theme={theme}>
      <CheckoutFrameProvider state={{ ...state }}>
        <Page state={state}>
          <SharableMetadata merchantName={merchantName} paymentReason={name} />
          <div className='main-wrapper'>
            <div className='main-wrapper__IFrame'>
              <CancelButton />
              <ComponentContainer>
                {!liveMode && <TestBar />}
                <ShoppingCartMobile showIntro={showIntro} setShowIntro={setShowIntro} />
                <div id={COMPONENT_CONTAINER_IDENTIFIER} />
                {!contentLoaded ? <PaymentsOptionsSkeleton /> : <AgreementContentPrivacyPolicy />}
              </ComponentContainer>
            </div>
            <ShoppingCartDesktop />
          </div>
        </Page>
      </CheckoutFrameProvider>
    </ThemeProvider>
  );
};
